import { Clock, Mail, MessageCircle, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const contactMethods = [{
  icon: Phone,
  title: "Phone Support",
  value: "(623) 268-8618",
  link: "tel:6232688618",
  description: "Direct line to our equipment specialists for immediate assistance."
}, {
  icon: Mail,
  title: "Email Inquiries",
  value: "hector@lynxservices.us",
  link: "mailto:hector@lynxservices.us",
  description: "Send us your project details for a comprehensive equipment quote."
}, {
  icon: MessageCircle,
  title: "WhatsApp",
  value: "Chat with Us",
  link: "https://wa.me/16232688618",
  description: "Message us for quick questions and equipment availability updates."
}, {
  icon: Clock,
  title: "Response Time",
  value: "Under 2 Hours",
  link: "/BookNowPage",
  description: "Rapid response commitment for all contractor and professional inquiries."
}];
export default function ContactInfo() {
  return <section id="contactinfo" className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold uppercase tracking-widest text-foreground font-default mb-4">
            Get In Touch
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-lg">
            You can reach us via phone, email, or WhatsApp to discuss your equipment needs, get instant quotes, and arrange your rental or reservation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {contactMethods.map((method, i) => <Card key={i} data-index={i} className="rounded-lg border-border shadow-sm hover:shadow-md transition-shadow text-center h-full flex flex-col justify-between bg-card">
              <CardHeader className="pb-2 pt-8">
                <div className="mx-auto bg-primary/10 p-4 rounded-lg mb-4">
                  <method.icon className="w-8 h-8 text-primary" />
                </div>
                <CardTitle className="font-default text-xl uppercase tracking-wide">
                  {method.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow flex flex-col justify-between pb-8">
                <p className="text-muted-foreground font-sans mb-6">
                  {method.description}
                </p>
                <Link to={method.link} className="text-foreground font-semibold hover:text-primary transition-colors text-lg font-default">
                  {method.value}
                </Link>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="font-default uppercase tracking-wide px-8">
            <Link to="/BookNowPage">Request a Quote Now</Link>
          </Button>
        </div>
      </div>
    </section>;
}